import Vue from 'vue';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').InsuranceContract} Contract
 */

/**
 * @param {State} state
 * @param {Contract[]} obj
 */
export function setContracts (state, obj) {
  state.contracts = obj || [];
}

/**
 * @param {State} state
 * @param {Object} obj
 * @param {boolean} [obj.upsert=true]
 * @param {Contract[]} obj.items
 */
export function updateInContracts (state, obj) {
  const { items, upsert } = obj;
  const list = state.contracts;
  items.forEach(item => {
    // find existing
    const index = list.findIndex(i => i.id === item.id);

    // update existing (inherit patient details)
    if (~index) {
      item = { ...item };
      item.patient = item.patient || list[index].patient;
      return Vue.set(list, index, item);
    }

    // add to list
    if (upsert) list.push(item);
  });
}

/**
 * @param {State} state
 * @param {Object} obj
 * @param {Contract[]} obj.items
 */
export function removeInContracts (state, obj) {
  const { items } = obj;
  const itemsMap = items.reduce((a, i) => ({ ...a, [i.id]: i }), {});
  const list = state.contracts;
  state.contracts = list.filter(i => !itemsMap[i.id]);
}
